module.exports = __webpack_public_path__ + "static/media/wallet_ic_w.a090ad2b.svg";